import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
} from '@mui/material';
import {
  Assessment as AssessmentIcon,
} from '@mui/icons-material';
import MainLayout from '../../components/layout/MainLayout';
import ClassAnalyticsCard from '../../components/teacher/ClassAnalyticsCard';
import QuizPerformanceCard from '../../components/teacher/QuizPerformanceCard';
import StrugglingStudentsCard from '../../components/teacher/StrugglingStudentsCard';

function TeacherAnalyticsPage() {
  return (
    <MainLayout>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <AssessmentIcon sx={{ fontSize: 40, color: 'primary.main' }} />
          <Box>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 600,
                color: 'text.primary',
                letterSpacing: '-0.01em',
              }}
            >
              Class Performance
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                fontSize: '0.95rem',
              }}
            >
              Track student progress, identify trends, and provide timely support
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Performance Analytics */}
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <ClassAnalyticsCard refreshTrigger={0} />
        </Grid>

        {/* Quiz Performance Analytics */}
        <Grid item xs={12}>
          <QuizPerformanceCard refreshTrigger={0} />
        </Grid>

        {/* Students Needing Attention */}
        <Grid item xs={12} data-demo-id="teacher-struggling-students">
          <StrugglingStudentsCard refreshTrigger={0} />
        </Grid>

        {/* Additional Analytics Sections - Placeholder */}
        <Grid item xs={12} md={6}>
          <Card elevation={2}>
            <CardHeader
              title="Topic Mastery"
              subheader="Coming Soon"
            />
            <Divider />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                Analyze student performance by topic area to identify strengths and areas needing improvement.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card elevation={2}>
            <CardHeader
              title="Assignment Completion"
              subheader="Coming Soon"
            />
            <Divider />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                Track assignment completion rates and identify students who may need additional support.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </MainLayout>
  );
}

export default TeacherAnalyticsPage;
